import { render, staticRenderFns } from "./BidsSuggestions.vue?vue&type=template&id=2a4a7b54"
import script from "./BidsSuggestions.vue?vue&type=script&lang=js"
export * from "./BidsSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports